import React, { useState } from 'react';
import { AlertCircleIcon, TrendingDownIcon, CheckCircleIcon } from 'lucide-react';
export const NegotiationSimulator = ({
  onSimulationComplete
}) => {
  const [initialPayment, setInitialPayment] = useState('');
  const [term, setTerm] = useState('');
  const [simulationResult, setSimulationResult] = useState(null);
  const [error, setError] = useState(null);
  const handleSimulate = () => {
    setError(null);
    // Validation
    if (!initialPayment || !term) {
      setError('Por favor complete todos los campos');
      return;
    }
    const initialPaymentValue = parseFloat(initialPayment);
    const termValue = parseInt(term);
    if (initialPaymentValue < 1000) {
      setError('La cuota inicial debe ser al menos S/ 1,000');
      return;
    }
    if (termValue < 3 || termValue > 24) {
      setError('El plazo debe estar entre 3 y 24 meses');
      return;
    }
    // Simulation calculation
    const totalDebt = 12450;
    const discountRate = initialPaymentValue >= 3000 ? 0.25 : 0.15;
    const discountAmount = totalDebt * discountRate;
    const remainingDebt = totalDebt - discountAmount - initialPaymentValue;
    const monthlyPayment = remainingDebt / termValue;
    const interestRate = 0.12; // 12% annual
    const monthlyInterest = interestRate / 12;
    const installments = [];
    let balance = remainingDebt;
    for (let i = 1; i <= termValue; i++) {
      const interest = balance * monthlyInterest;
      const principal = monthlyPayment - interest;
      balance -= principal;
      installments.push({
        number: i,
        payment: monthlyPayment,
        principal,
        interest,
        balance: Math.max(0, balance)
      });
    }
    const result = {
      totalDebt,
      discountRate,
      discountAmount,
      initialPayment: initialPaymentValue,
      remainingDebt,
      term: termValue,
      monthlyPayment,
      totalPayment: initialPaymentValue + monthlyPayment * termValue,
      savings: discountAmount,
      installments
    };
    setSimulationResult(result);
  };
  const handleAccept = () => {
    if (simulationResult) {
      onSimulationComplete(simulationResult);
    }
  };
  return <div className="space-y-8" data-id="element-962">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-963">
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-964">
          <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-965">
            Simulador de Negociación
          </h2>
          <div className="space-y-6" data-id="element-966">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-967">
              <div data-id="element-968">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-969">
                  Cuota Inicial (S/)
                </label>
                <div className="relative" data-id="element-970">
                  <input type="number" value={initialPayment} onChange={e => setInitialPayment(e.target.value)} className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ej: 2000" data-id="element-971" />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-972">
                    <span className="text-gray-500" data-id="element-973">S/</span>
                  </div>
                </div>
                <p className="mt-1 text-xs text-gray-500" data-id="element-974">
                  Mínimo S/ 1,000. Pago mayor a S/ 3,000 obtiene 25% de
                  descuento.
                </p>
              </div>
              <div data-id="element-975">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-976">
                  Plazo (meses)
                </label>
                <select value={term} onChange={e => setTerm(e.target.value)} className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-977">
                  <option value="" data-id="element-978">Seleccione un plazo</option>
                  <option value="3" data-id="element-979">3 meses</option>
                  <option value="6" data-id="element-980">6 meses</option>
                  <option value="12" data-id="element-981">12 meses</option>
                  <option value="18" data-id="element-982">18 meses</option>
                  <option value="24" data-id="element-983">24 meses</option>
                </select>
                <p className="mt-1 text-xs text-gray-500" data-id="element-984">
                  Plazo máximo de 24 meses.
                </p>
              </div>
            </div>
            {error && <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start" data-id="element-985">
                <AlertCircleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-986" />
                <p className="text-sm text-red-600" data-id="element-987">{error}</p>
              </div>}
            <div className="flex justify-center" data-id="element-988">
              <button onClick={handleSimulate} className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-medium" data-id="element-989">
                Simular
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-990">
          <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-991">
            Deuda Actual
          </h2>
          <div className="space-y-4" data-id="element-992">
            <div className="flex justify-between items-center" data-id="element-993">
              <span className="text-sm text-gray-500" data-id="element-994">Deuda Total</span>
              <span className="text-lg font-medium" data-id="element-995">S/ 12,450.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-996">
              <span className="text-sm text-gray-500" data-id="element-997">Capital</span>
              <span className="text-sm font-medium" data-id="element-998">S/ 10,000.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-999">
              <span className="text-sm text-gray-500" data-id="element-1000">Intereses</span>
              <span className="text-sm font-medium" data-id="element-1001">S/ 2,450.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-1002">
              <span className="text-sm text-gray-500" data-id="element-1003">Días en Mora</span>
              <span className="text-sm font-medium text-red-600" data-id="element-1004">120 días</span>
            </div>
            <div className="pt-4 border-t border-gray-200" data-id="element-1005">
              <p className="text-xs text-gray-500" data-id="element-1006">
                El monto a pagar puede variar según el plan de negociación
                seleccionado.
              </p>
            </div>
          </div>
        </div>
      </div>
      {simulationResult && <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1007">
          <div className="flex justify-between items-start mb-6" data-id="element-1008">
            <h2 className="text-lg font-medium text-gray-900" data-id="element-1009">
              Resultado de la Simulación
            </h2>
            <div className="flex items-center text-green-600" data-id="element-1010">
              <TrendingDownIcon className="h-5 w-5 mr-1" data-id="element-1011" />
              <span className="text-sm font-medium" data-id="element-1012">
                Ahorro: S/ {simulationResult.savings.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-1013">
            <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1014">
              <p className="text-sm text-gray-500" data-id="element-1015">Deuda Original</p>
              <p className="text-lg font-medium" data-id="element-1016">
                S/ {simulationResult.totalDebt.toFixed(2)}
              </p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-1017">
              <p className="text-sm text-green-600" data-id="element-1018">
                Descuento ({(simulationResult.discountRate * 100).toFixed(0)}%)
              </p>
              <p className="text-lg font-medium text-green-700" data-id="element-1019">
                S/ {simulationResult.discountAmount.toFixed(2)}
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-1020">
              <p className="text-sm text-blue-600" data-id="element-1021">Total a Pagar</p>
              <p className="text-lg font-medium text-blue-700" data-id="element-1022">
                S/ {simulationResult.totalPayment.toFixed(2)}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1023">
            <div data-id="element-1024">
              <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-1025">
                Detalle del Pago
              </h3>
              <div className="space-y-2" data-id="element-1026">
                <div className="flex justify-between" data-id="element-1027">
                  <span className="text-sm text-gray-500" data-id="element-1028">Cuota Inicial</span>
                  <span className="text-sm font-medium" data-id="element-1029">
                    S/ {simulationResult.initialPayment.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-1030">
                  <span className="text-sm text-gray-500" data-id="element-1031">Saldo Restante</span>
                  <span className="text-sm font-medium" data-id="element-1032">
                    S/ {simulationResult.remainingDebt.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-1033">
                  <span className="text-sm text-gray-500" data-id="element-1034">Plazo</span>
                  <span className="text-sm font-medium" data-id="element-1035">
                    {simulationResult.term} meses
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-1036">
                  <span className="text-sm text-gray-500" data-id="element-1037">Cuota Mensual</span>
                  <span className="text-sm font-medium" data-id="element-1038">
                    S/ {simulationResult.monthlyPayment.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col" data-id="element-1039">
              <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-1040">
                Resumen
              </h3>
              <div className="flex-1 flex items-center justify-center" data-id="element-1041">
                <div className="text-center" data-id="element-1042">
                  <CheckCircleIcon className="h-10 w-10 text-green-500 mx-auto mb-2" data-id="element-1043" />
                  <p className="text-sm text-gray-600" data-id="element-1044">
                    Esta propuesta representa un
                  </p>
                  <p className="text-xl font-bold text-green-600" data-id="element-1045">
                    {(simulationResult.discountRate * 100).toFixed(0)}% de
                    descuento
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-1046">sobre su deuda total</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-1047">
            <button onClick={handleAccept} className="px-8 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 font-medium" data-id="element-1048">
              Acordar Negociación
            </button>
          </div>
        </div>}
    </div>;
};